import React from "react";
import "./WorkExperience.css";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { MdGroupWork } from "react-icons/md";

const WorkExperience = () => {
  const data = [
    {
      companyname: "Google",
      position: "Full Stack Developer",
      des: "A full-stack developer at Google is a versatile software engineer responsible for both front-end and back-end development, creating innovative web applications and services to enhance user experiences and drive technological advancements.",
      year: "2023 - 2022",
      techskill: [
        { techname: "Node Js" },
        { techname: "Express Js" },
        { techname: "React Js" },
        { techname: "Material UI" },
      ],
    },
    {
      companyname: "Facebook",
      position: "Front-end- Developer",
      des: "Facebook Front-end Developer: Shape the user experience of one of the world's leading social platforms, crafting dynamic and visually engaging interfaces that connect billions of people.",
     year: "2020 - 2021",
      techskill: [
        { techname: "Swift" },
        { techname: "Kotlin" },
        { techname: "React Native" },
        { techname: "Flutter" },
      ],
    },
    {
      companyname: "Youtube",
      position: "Front-end- Developer",
      des: "Elevate user engagement on the world's largest video-sharing platform, designing captivating front-end experiences for millions of viewers and creators.",
      year: "2018 - 2019",
      techskill: [
        { techname: "AWS" },
        { techname: "Azure" },
        { techname: "Google Cloud" },
        { techname: "Express" },
      ],
    },
    {
      companyname: "UI/UX Innovators",
      position: "UI/UX Designer",
      des: "Designing intuitive and visually appealing interfaces for web and mobile applications. Proficient in Sketch, Figma, and Adobe XD since 2017.",
      year: "2017 - 2018",
      techskill: [
        { techname: "Sketch" },
        { techname: "Figma" },
        { techname: "Adobe XD" },
        { techname: "Node.js" },
      ],
    },
    {
      companyname: "Microsoft",
      position: "Software Engineer",
      des: "Building robust and scalable software solutions using Java, Python, and Spring Boot. Delivering high-quality code since 2016.",
      year: "2016 - 2017",
      techskill: [
        { techname: "Java" },
        { techname: "Python" },
        { techname: "Spring-Boot" },
        { techname: "Node.js" },
      ],
    },
    {
      companyname: "WhatsApp",
      position: "DevOps Engineer",
      des: "Streamlining development pipelines with Docker, Kubernetes, Jenkins, and CI/CD. Ensuring seamless deployments since 2015.",
      year: "2015 - 2016",
      techskill: [
        { techname: "Docker" },
        { techname: "Kubernetes" },
        { techname: "Jenkins" },
        { techname: "CI/CD" },
      ],
    },
  ];

  const colors = [
    "#fcba03",
    "#362b31",
    "#1aeb13",
    "#f39c12",
    "#c9170e",
    "#0ef0ce",
  ];
  return (
    <div className="container workexperience-section" id="workexperience">
      <div className="section-title">
        <h5> Work-Experience </h5>
        <span className="line"></span>
      </div>

      <VerticalTimeline lineColor="#FF1042">
        {data.map((item, index) => (
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: colors[index], color: "#fff" }}
            contentArrowStyle={{ borderRight: "7px solid  rgb(33, 150, 243)" }}
            date={item.year}
            dateClassName="date-class"
            iconStyle={{ background: colors[index], color: "#fff" }}
            icon={<MdGroupWork />}
          >
            <h3 className="vertical-timeline-element-title">
              {item.companyname}
            </h3>
            <h5 className="vertical-timeline-element-subtitle">
              {item.position}
            </h5>
            <div className="row">
              {item.techskill.map((tech, index) => (
                <div
                  className="col-xl-4 col-lg-4 col-md-6 col-sm-12"
                  key={index}
                >
                  <div className="tech-skills">
                    <p>{tech.techname}</p>
                  </div>
                </div>
              ))}
            </div>
            <p>{item.des}</p>
          </VerticalTimelineElement>
        ))}
      </VerticalTimeline>
    </div>
  );
};

export default WorkExperience;